import "./home.css";
import { useRef, useState, useEffect } from "react";
import useWindowDimensions from "../Hook/useWindowDimensions";
import logo from "../media/logo.png";
const Header = () => {
  const [showopt, setShowopt] = useState(true);
  const [optmobile, setoptmobile] = useState(false);
  const { height, width } = useWindowDimensions();

  useEffect(() => {
    if (width <= 600) {
      setShowopt(false);
    } else {
      setShowopt(true);
    }
  });

  const [shownav, setshownav] = useState(false);

  const handleshow = () => {
    setshownav((current) => !current);
  };

  return (
    <header className="m-header">
      <div className="container">
        <a href="/">
          <img style={{    width:' 105px',
    height: '53px' }}
            className="lazyload"
            src={logo}
          />
        </a>

        {showopt && (
          <div className="m-header__right">
            <nav>
              <ul id="menu-top-menu" className="menu">
                <li className="menu-item menu-item-has-children">
                  {" "}
                  <a href="/">Home</a>
                </li>
                <li className="menu-item menu-item-has-children">
                  {" "}
                  <a href="/" style={{ cursor: "pointer" }}>
                    Subscription
                  </a>
                </li>
                <li className="menu-item menu-item-has-children">
                  {" "}
                  <a href="/Terms">Terms</a>
                </li>
                <li className="menu-item menu-item-has-children">
                  {" "}
                  <a href="/refund">Refund Policy</a>
                </li>
                <li className="menu-item menu-item-has-children">
                  {" "}
                  <a href="/FAQ">FAQ</a>
                </li>
                <li className="menu-item menu-item-has-children">
                  {" "}
                  <a href="/About">About Us</a>
                </li>
              </ul>
            </nav>
            <div className="m-header__right__cta">
              <a href="/Contactus" className="btn-yellow">
                Contact us
              </a>
            </div>
          </div>
        )}

        {shownav && (
          <div className="m-header__right">
            <nav>
              <ul id="menu-top-menu" className="menu">
                <li className="menu-item menu-item-has-children">
                  {" "}
                  <a href="/">Home</a>
                </li>
                <li className="menu-item menu-item-has-children">
                  {" "}
                  <a href="/" style={{ cursor: "pointer" }}>
                    Subscription
                  </a>
                </li>
                <li className="menu-item menu-item-has-children">
                  {" "}
                  <a href="/Terms">Terms</a>
                </li>
                <li className="menu-item menu-item-has-children">
                  {" "}
                  <a href="/refund">Refund Policy</a>
                </li>
                <li className="menu-item menu-item-has-children">
                  {" "}
                  <a href="/FAQ">FAQ</a>
                </li>
                <li className="menu-item menu-item-has-children">
                  {" "}
                  <a href="/About">About Us</a>
                </li>
              </ul>
            </nav>
            <div className="m-header__right__cta">
              <a href="/Contactus" className="btn-yellow">
                Contact us
              </a>
            </div>
          </div>
        )}

        <div className="hamburger-wrap">
          {shownav ? (
            <div className="hamburger">
              <a className="closei" onClick={handleshow}>
                <i class="fa-solid fa-xmark"></i>
              </a>
            </div>
          ) : (
            <div className="hamburger">
              <a onClick={handleshow} className="main-nav-toggle">
                <i>Menu</i>
              </a>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
